module.exports = __webpack_public_path__ + "media/images/a2/lottie/globe-animation-min.json";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/a2/lottie/globe-animation-min.json
// module id = 4
// module chunks = 0